module.exports = __webpack_public_path__ + "static/img/news2.c425aa6.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/news2.png
// module id = rXBt
// module chunks = 7